export default {
  time_format: 'MMMM Do YYYY, H:mm:ss',
};
